// src/features/riskmize/severity.js
// Shared severity colors + ordering for the Riskmize module.
// Any UI surface rendering incidents must import from here so the map, list, and popup stay in sync.

export const SEVERITY_COLORS = {
  critical: '#dc2626',
  high: '#ef4444',
  medium: '#f59e0b',
  low: '#94a3b8',
};

export const SEVERITY_BG_CLASSES = {
  critical: 'bg-red-600',
  high: 'bg-red-500',
  medium: 'bg-amber-500',
  low: 'bg-slate-400',
};

export const SEVERITY_ORDER = ['low', 'medium', 'high', 'critical'];
export const SEVERITY_RANK = Object.fromEntries(SEVERITY_ORDER.map((s, i) => [s, i]));
